import { render, staticRenderFns } from "./project-listing.vue?vue&type=template&id=fde304ce&"
import script from "./project-listing.vue?vue&type=script&lang=js&"
export * from "./project-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports